import { TrueFalseOutline } from '@lyearn/icons';
import { isValidSubmission } from '@/modules/corporate/modules/questions/fields/single-select/utils';
import { QuizViewField } from '@/modules/corporate/modules/questions/fields/types';
import { QuestionTypeEnum } from '@/types/schema';

import Player from '../../../components/Player';
import QuestionReview from '../../../components/QuestionReview';
import { getQuestionEvaluation } from '../../../utils';

const TrueOrFalseViewField: QuizViewField = {
  getQuestionEvaluation,
  isValidSubmission,
  Player,
  type: QuestionTypeEnum.TrueOrFalse,
  getQuestionLabel: () => 'QuizPlayer:TrueOrFalse',
  labelKey: 'QuizPlayer:QuestionType.TrueOrFalse',
  Icon: TrueFalseOutline,
  Review: QuestionReview,
  getShouldAutoAdvance: () => true,
};

export default TrueOrFalseViewField;
